import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IBaryInput } from 'models/bary-input';
import { BaryComponentHelper } from 'app/shared/util/bary-component-helper';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { BaryTitleComponent } from '../bary-title/bary-title.component';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';
import { BaryIconComponent } from '../bary-icon/bary-icon.component';

@Component({
  selector: 'jhi-bary-input-switch',
  templateUrl: './bary-input-switch.component.html',
  styleUrls: ['./bary-input-switch.component.scss'],
  standalone: true,
  imports: [CommonModule, MDBBootstrapModulesPro, ReactiveFormsModule, BaryTitleComponent, BaryIconComponent],
})
export class BaryInputSwitchComponent implements IBaryInput, OnInit {
  @Input() id = BaryComponentHelper.makeId();
  @Input() name?: string;
  @Input() disabled: boolean = false;
  @Input() label?: string;
  @Input() offLabel?: string;
  @Input() onLabel?: string;
  @Input() tooltip?: string;
  @Input() tooltipOnLabel?: string;
  @Input() value?: boolean;
  @Input() control!: FormControl;
  @Input() withColor?: boolean;

  @Output() onChangeEvent = new EventEmitter();

  protected readonly FAS = FaDirectiveEnum.FAS;

  public ngOnInit(): void {
    if (!this.control) {
      this.control = this.value ? new FormControl(this.value) : new FormControl(false);
    }
    if (this.disabled) {
      this.control.disable();
    }
  }

  public handleChange(): void {
    this.onChangeEvent.emit(this.control.value);
  }
}
